module.exports = __webpack_public_path__ + "img/add_event.54fd419a.gif";